<script>
    import axios from 'axios'
    import {nextTick} from "vue";
    import AdaptersDialog from "../../../component/adapters/Dialog.vue";
    import Checkbox from "primevue/checkbox";
    import TemplatesLabelCounts from "../../../templates/LabelCounts.vue";
    import Textarea from "primevue/textarea";

    export default {
        data() {
            return {
                loading: false,
                list: null,
                error: null,
                limit: 300,
                model: {}
            }
        },
        props: ["name", "reportRid", "type", "target"],
        methods: {
            save(){
                let self = this;
                if(this.getData.length === 0){
                    this.error = this.$t('lang.group_report.tmpl_length_1_err');
                    return false;
                }
                if(this.getData.length > this.limit){
                    this.error = this.$t('lang.group_report.limit_count_err', [this.limit]);
                    return false;
                }

                self.loading = true;

                axios({
                    method: 'post',
                    url: this.getApiUrl,
                    withCredentials: true,
                    data: Object.assign({}, this.model, {templates: self.getData})
                })
                    .then(function (response) {

                        self.loading = false;
                        window.location.reload();

                    })
                    .catch(function (error) {
                        self.loading = false;
                        self.error = error.response.data.message;
                    });


            },
            onClose() {
                this.list = null;
                this.error = null
            },
            onOpen() {
                let self = this;
                nextTick(() => {
                    self.$refs["modalInput"].$el.focus()
                });
                if (this.target == "all") {
                    this.model = {
                        organic: true,
                        context: true,
                    };
                } else {
                    this.model = {
                        organic: this.target == "organic",
                        context: this.target == "context",
                    };
                }
            }
        },
        computed: {
            getApiUrl(){
                return this.$config.API_URL + '/report/group/' + this.type + '/template/' + this.reportRid;
            },
            getData(){
                if(this.list){
                    return this.list.replace(/\r\n/g,"\n").split("\n").filter(item => {return item != ""});
                }
                return [];
            },
            btnModalLabel(){
                return this.type === 'import' ? this.$t('lang.main.btn.add') : this.$t('lang.main.btn.delete');
            },
            count(){
                return this.getData.length;
            },
            getOrganicLabel() {
                return this.type === 'import' ? this.$t('lang.main.f_import_organic') : this.$t('lang.main.f_delete_organic');
            },
            getContextLabel() {
                return this.type === 'import' ? this.$t('lang.main.f_import_context') : this.$t('lang.main.f_delete_context');
            },
        },
        components: {
            TemplatesLabelCounts,
            AdaptersDialog,
            Checkbox,
            Textarea,
        },
    }
</script>
<template>
    <AdaptersDialog
        :listener-id="name"
        :callback-on-show="onOpen"
        :callback-on-hide="onClose"
        :header="$t('lang.group_report.delete_key_by_tmpl')"
        :loading="loading"
        :error-message="error"
        :callback-agree="save"
        :button-agree-label="btnModalLabel"
    >
        <template #content>
            <div class="field">
                <TemplatesLabelCounts :text="$t('lang.group_report.tmpl_list_rules')" :count="count" :limit="limit" />
                <Textarea v-model="list" rows="6" ref="modalInput" />
            </div>
            <p class="flex flex-column row-gap-2">
                {{ $t('lang.group_report.tmpl_help_label') }}
                <label><code>%</code>: {{ $t('lang.group_report.tmpl_help_label_1') }}</label>
                <label><code>_</code>: {{ $t('lang.group_report.tmpl_help_label_2') }}</label>
            </p>
            <div class="formgroup-inline">
                <div class="field-checkbox">
                    <Checkbox v-model="model.organic" inputId="organic" binary />
                    <label for="organic">{{ getOrganicLabel }}</label>
                </div>
                <div class="field-checkbox">
                    <Checkbox v-model="model.context" inputId="context" binary />
                    <label for="context">{{ getContextLabel }}</label>
                </div>
            </div>
        </template>
    </AdaptersDialog>
</template>
